export enum PerfilNumeroEnum {
  Admin = 1
}

export enum PerfilEnum {
  Administracao = 'ADMINISTRACAO',
  Cadastros = 'CADASTROS',
  Figurino = 'FIGURINO',
  ContinuistaSet = 'CONTINUISTASET',
  Caracterizacao = 'CARACTERIZACAO',
  Chamadas = 'CHAMADAS',
  Diretoria = 'DIRETORIA',
  Arte = 'ARTE',
  Relatorios = 'RELATORIOS',
  RelatoriosGravacao = 'RELATORIODEGRAVACAO',
  DecupagemArtistica = 'DECUPAGEMARTISTICA',
  ContinuistaCoordenador = 'CONTINUISTACOORD',
  Leitura = 'LEITURA',
  LeituraTotal = 'LEITURATOTAL',
  GrupoTeste = 'GRUPOTESTE',
  GrupoTesteQA = 'GRUPOTESTEQA',
  Comercial = 'COMERCIAL'
}
